import { Component } from "@angular/core";
import {
  IonicPage,
  NavController,
  NavParams,
  LoadingController
} from "ionic-angular";
import { Http } from "@angular/http";
import config from "../../config/config";
import { PerfilPage } from "../perfil/perfil";

/**
 * Generated class for the ListaParceirosPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-lista-parceiros',
  templateUrl: 'lista-parceiros.html',
})
export class ListaParceirosPage {
  usuario: any;
  bemVindo: any;
  operarios: any[];
  items: any[];
  pes: number;
  grupo: any;
 
  constructor(
    public navCtrl: NavController,
    private _http: Http,
    public loadingCtrl: LoadingController,

    public navParams: NavParams
  ) {}

  ionViewDidLoad() {
    this.usuario = this.navParams.get("usuario");
    this.bemVindo = this.navParams.get("bemVindo");
    this.grupo = this.navParams.get("grupo");

    this.todos();
  }
  todos() {
    let loading = this.loadingCtrl.create({
      content: "Aguarde"
    });
    loading.present();
    this._http
      .get(config.urlAPI + "usuario/parceiros", {})
      .map(res => res.json())
      .toPromise()
      .then(res => {
        let env = [];

        for (let w = 0; w < res.length; w++) {
          const element = res[w];

          if (res[w].dados.foto == null) {
            res[w].dados.foto = "/public/perfildefault.jpg";
            // this.foto = res[w].dados.foto;
          }
          let ineter = "";
          if (element.dados.interesse != null) {
            let inte = JSON.parse(element.dados.interesse);
            for (let q = 0; q < inte.length; q++) {
              if (inte[q].isChecked) {
                ineter += inte[q].val + ", ";
              }
            }
          }
          res[w].intereses = ineter;
          env.push(res[w]);
          this.operarios = env;
          this.items = env;
        }
        loading.dismiss();
      })
      .catch(error => {
        loading.dismiss();
      });
  }
  perfil(item) {
    this.navCtrl
      .push(PerfilPage, {
        usuario: item,
        dados: item.dados,
        dependentes: item.dependentes,
        grupo: this.grupo,
        adm: this.usuario,
        bemVindo: this.bemVindo,
        usuarioIdAuditoria: this.usuario.id
      })
      .then(() => {
        this.navCtrl.getActive().onDidDismiss(data => {
          this.ionViewDidLoad();
        });
      });
  }
  initializeItems() {
    this.items = [];

    for (var i = 0; i < this.operarios.length; ++i) {
      var it = this.operarios[i];
      this.items.push(it);
    }
  }
  getItems(ev: any) {
    this.initializeItems();
    const val = ev;

    // if the value is an empty string don't filter the items
    if (this.pes == 1) {
      if (val && val.trim() != "") {
        this.items = this.items.filter(item => {
          return (
            item.nome
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
          );
        });
      } else {
        this.initializeItems();
      }
    }
    if (this.pes == 2) {
      if (val && val.trim() != "") {
        this.items = this.items.filter(item => {
          return (
            item.cpf
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
          );
        });
      } else {
        this.initializeItems();
      }
    }
    if (this.pes == 3) {
      if (val && val.trim() != "") {
        this.items = this.items.filter(item => {
          return (
            item.intereses
              .toString()
              .toLowerCase()
              .indexOf(val.toLowerCase()) > -1
          );
        });
      } else {
        this.initializeItems();
      }
    }
    ev = "";
  }
  filtrofunc(pes) {}

}



// WEBPACK FOOTER //
// ./src/pages/lista-parceiros/lista-parceiros.ts